import ReactMarkdown from "react-markdown";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import type { Components } from "react-markdown";

// Sanitize-Schema absichtlich strenger als der ReactMarkdown-Default: keine Bilder, keine Tabellen,
// keine HTML-Attribute ausser den fuer Links noetigen. Damit kann ein Administrator, der die
// Sperrnotiz oder aehnliche Texte pflegt, keinen HTML-/Script-Angriff auf andere Benutzer der
// Anwendung starten - selbst wenn er den Text absichtlich mit Roh-HTML fuellt, wird alles
// entfernt, was nicht in dieser Liste steht.
const schema = {
  ...defaultSchema,
  tagNames: ["p", "strong", "em", "code", "a", "ul", "ol", "li", "br", "h1", "h2", "h3"],
  attributes: {
    ...defaultSchema.attributes,
    a: ["href", "title"],
  },
  // URL-Protokolle einschraenken - kein "javascript:" oder "data:"-URI, die einen Script-Kontext
  // eroeffnen koennten. mailto und tel sind fachlich sinnvoll (Kontaktangaben in der Sperrnotiz).
  protocols: {
    ...defaultSchema.protocols,
    href: ["http", "https", "mailto", "tel"],
  },
};

// Links oeffnen bewusst in einem neuen Fenster mit rel="noreferrer noopener" - siehe
// OWASP-Empfehlung fuer external links; verhindert Reverse-Tabnabbing.
const components: Components = {
  a: ({ node: _node, children, href, ...rest }) => (
    <a href={href} target="_blank" rel="noreferrer noopener" className="text-primary underline hover:opacity-80" {...rest}>
      {children}
    </a>
  ),
  p: ({ node: _node, children }) => <p className="mb-2 last:mb-0">{children}</p>,
  ul: ({ node: _node, children }) => <ul className="mb-2 ml-6 list-disc">{children}</ul>,
  ol: ({ node: _node, children }) => <ol className="mb-2 ml-6 list-decimal">{children}</ol>,
  h1: ({ node: _node, children }) => <h2 className="mb-2 text-lg font-semibold">{children}</h2>,
  h2: ({ node: _node, children }) => <h3 className="mb-2 text-base font-semibold">{children}</h3>,
  h3: ({ node: _node, children }) => <h4 className="mb-2 text-base font-semibold">{children}</h4>,
};

export interface MarkdownProps {
  source: string;
  className?: string;
}

/**
 * Rendert eine vertrauenswuerdige aber administratorseitig editierbare Markdown-Zeichenkette. Wird
 * derzeit fuer die Sperrnotiz (BlockedUserScreen) und die Vorschau im Admin-Editor genutzt.
 */
export function Markdown({ source, className }: MarkdownProps) {
  return (
    <div className={className}>
      <ReactMarkdown rehypePlugins={[[rehypeSanitize, schema]]} components={components}>
        {source}
      </ReactMarkdown>
    </div>
  );
}
